import { AxiosInstance } from 'axios';
import baseAxios from '@/helpers/forms/axios';

export type MerchantEntitlement = 'sourcing' | 'paid_channels';

export interface MerchantSearchResult {
    uuid: string
    name: string
    primaryEmail: string
}

export interface MerchantSearchPage {
    data: MerchantSearchResult[]
    currentPage: number
    lastPage: number
}

interface MerchantEntitlementsApi {
    searchMerchants: (expression: string, page?: number) => Promise<MerchantSearchPage>
    fetchEntitlements: (merchantUuid: string) => Promise<MerchantEntitlement[]>
    grantEntitlement: (merchantUuid: string, entitlement: MerchantEntitlement) => Promise<void>
    revokeEntitlement: (merchantUuid: string, entitlement: MerchantEntitlement) => Promise<void>
}

export default (axios: AxiosInstance = baseAxios): MerchantEntitlementsApi => ({
    searchMerchants: async (expression: string, page = 1): Promise<MerchantSearchPage> => {
        const response = await axios.get<MerchantSearchPage>('/api/admin/merchants/search', {
            params: { q: expression, page, perPage: 20 },
        });

        return response.data;
    },

    fetchEntitlements: async (merchantUuid: string): Promise<MerchantEntitlement[]> => {
        const response = await axios.get<{ data: MerchantEntitlement[] }>(`/api/admin/merchants/${encodeURIComponent(merchantUuid)}/entitlements`);

        return response.data.data;
    },

    grantEntitlement: async (merchantUuid: string, entitlement: MerchantEntitlement): Promise<void> => {
        await axios.put(`/api/admin/merchants/${encodeURIComponent(merchantUuid)}/entitlements/${entitlement}`);
    },

    revokeEntitlement: async (merchantUuid: string, entitlement: MerchantEntitlement): Promise<void> => {
        await axios.delete(`/api/admin/merchants/${encodeURIComponent(merchantUuid)}/entitlements/${entitlement}`);
    },
});
